import React from 'react';
import { connect } from 'react-redux';

import { actionShared } from '../../containers/Widget/actions.js';

import ShareButton from './ShareButton';
import LinkedInIcon from '../Svg/LinkedInIconFooter';
import PropTypes from 'prop-types';

import { copyFor } from '../../copy/copy';

const linkedInClickAction = (
    shareUrl,
    partnerName,
    publisherName,
    isEmbed,
    widgetRequestId
) => {
    if (isEmbed) {
        shareUrl += `?widgetId=${widgetRequestId}`;
    }
    const title = copyFor('sharing', 'linkedinTitle', undefined, undefined, {
        partnerName
    });
    const summary = copyFor('sharing', 'linkedinSummary', undefined, undefined, {
        publisherName
    });
    const url = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
        shareUrl
    )}&title=${encodeURIComponent(title)}&summary=${encodeURIComponent(summary)}`;
    window.open(url, 'popup', 'width=600,height=600');
    return true;
};

const LinkedInShare = props => (
    <ShareButton
        handleClick={() =>
            linkedInClickAction(
                props.shareUrl,
                props.partnerName,
                props.publisherName,
                props.isEmbed,
                props.widgetRequestId
            ) && props.actionShared('linkedin')
        }
    >
        <LinkedInIcon />
    </ShareButton>
);

LinkedInShare.propTypes = {
    actionShared: PropTypes.func.isRequired,
    isEmbed: PropTypes.bool.isRequired,
    partnerName: PropTypes.string,
    publisherName: PropTypes.string,
    shareUrl: PropTypes.string.isRequired,
    widgetRequestId: PropTypes.string.isRequired
};

export default connect(
    state => ({
        shareUrl: state.widget.articleUrl,
        publisherName: state.widget.publisherName || 'Speakable',
        partnerName:
            state.widget.activeAction.partner !== undefined
                ? state.widget.activeAction.partner.twitterMention !== undefined
                    ? '@' + state.widget.activeAction.partner.twitterMention
                    : state.widget.activeAction.partner.name
                : 'Speakable'
    }),
    {
        actionShared
    }
)(LinkedInShare);
